

let resetCookies = document.querySelector('#reset_cookies')
if(resetCookies){
  resetCookies.addEventListener('click', function(){
    if(!this.dataset.cookie) return
    document.cookie = this.dataset.cookie+'="";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    location.reload();
  })
}

